import { render, staticRenderFns } from "./SingularityMilestonePane.vue?vue&type=template&id=2cc17f23&"
import script from "./SingularityMilestonePane.vue?vue&type=script&lang=js&"
export * from "./SingularityMilestonePane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports